export default __webpack_public_path__ + "static/Honda-0a3ca41a644b9e564f111cbedbeaa49c.png";